import AttributeQuery from 'Query/Attribute.query';
import { getAttribute, removeAttributesFromState } from 'Store/Attribute/Attribute.action';
import { fetchQuery } from 'Util/Request';

export class AttributeDispatcher {
    async getAttributeByCode(dispatch, attributeCode) {
        const attributeQuery = new AttributeQuery();
        const { customAttributeMetadata } = await fetchQuery(attributeQuery.getAttributeByCode(attributeCode));
        dispatch(getAttribute(customAttributeMetadata?.items[0]));
    }
    removeAttributesFromState(dispatch) {
        dispatch(removeAttributesFromState());
    }
}

export default new AttributeDispatcher();
